import { MainLayout } from 'components';
import React, { useEffect, useState } from 'react';
import { Switch } from 'antd';
import pageTitleStore from 'store/pageTitleStore';
import { Col, Form, Input, Row, Space, Table, DatePicker, Select } from 'antd';
import Button from 'components/Button';
import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import useQueryParam from 'hooks/useQueryPrams';
import {
  AddIcon,
  EditGrayIcon,
  EditIcon,
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
} from 'assets/svg';
import updateQueryStringParameter from 'utils/updateQueryStringParameter';
import { useHistory } from 'react-router-dom';
import { IGetUserQuery } from 'interface/user.interface';
import { HocChangePagination } from 'utils/HocChangePagination';
import CartApi from 'apis/CartApi';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { useMutation, useQuery } from 'react-query';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import PofTypeApi from 'apis/PofTypeApi';
import ModalEditCartList from './ModalEditCartList';

type FixedType = 'left' | 'right' | boolean;

export default function CartList() {
  const history = useHistory();
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [openModalEditCartList, setOpenModalEditCartList] = useState(false);
  const [currentCartList, setCurrentCartList] = useState();

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const { RangePicker } = DatePicker;
  const [form] = useForm();
  const { Option } = Select;
  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const params = {
    page: page,
    page_size: page_size,
    ...(formSubmitParams && formSubmitParams),
  };

  const { data: lstPofType } = useQuery(['getAll'], () =>
    PofTypeApi.getCartType()
  );

  const {
    data: lstCartData,
    isLoading: getCartsLoading,
    mutate: refetch,
  } = useMutation(['get'], () => CartApi.get(params));

  const SwitchOnChange = (checked: boolean) => {
    console.log(`switch to ${checked}`);
  };

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã giỏ hàng',
      dataIndex: 'cart_code',
      width: 160,
    },
    {
      title: 'Loại giỏ hàng',
      dataIndex: 'cart_type_name',
      width: 180,
    },
    {
      title: 'Tên giỏ hàng',
      dataIndex: 'cart_name',
      width: 470,
    },
    {
      title: 'Bộ phận phát triển',
      dataIndex: 'nhan_hang',
      width: 160,
    },
    {
      title: 'Người khai báo',
      dataIndex: 'user_created',
      width: 180,
      render: (user) => user?.fullName,
    },
    {
      title: 'Phòng ban',
      dataIndex: 'user_created',
      width: 180,
      render: (user) => user?.division,
    },
    {
      title: 'Đơn vị phát hành',
      dataIndex: 'user_created',
      width: 200,
      render: (user) => user?.departmentName,
    },
    {
      title: 'Công ty phát hành',
      dataIndex: 'user_created',
      width: 170,
      render: (user) => user?.organization,
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      width: 150,
      render: (status) => (status == 0 ? 'Mới' : 'Đã phát hành'),
    },
    {
      title: 'Ngày bắt đầu',
      dataIndex: 'release_date',
      width: 140,
      render: (release_date) => {
        return moment(release_date).format('DD/MM/YYYY');
      },
    },
    {
      title: 'Ngày hết hạn',
      dataIndex: 'expiration_date',
      width: 140,
      render: (expiration_date) => {
        return moment(expiration_date).format('DD/MM/YYYY');
      },
    },
    {
      title: 'Cập nhật lần cuối',
      dataIndex: 'updated_at',
      width: 150,
      render: (updated_at) => {
        return updated_at ? moment(updated_at).format('DD/MM/YYYY') : '';
      },
    },

    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 100,
      align: 'center',
      render: (_: any, record: any) => (
        <div className="flex justify-around items-center">
          <button onClick={() => handleEditDetailCart(record.id)}>
            <EyeIcon />
          </button>
          {/* {record.status == 0 &&
          Date.now() < new Date(record.expiration_date).getTime() ? (
            <EditIcon
              className="cursor-pointer"
              onClick={() => {
                onEditCart({ currentData: record });
              }}
            />
          ) : (
            <EditGrayIcon className="cursor-pointer" />
          )}
          <Switch size="small" defaultChecked onChange={SwitchOnChange} /> */}
        </div>
      ),
    },
  ];

  const handleEditDetailCart = (id: number) => {
    history.push(`/cart-details/${id}`);
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      if (key == 'release_date') {
        const ranges: any = filteredData[key];
        stringifiedData['release_from'] = String(ranges[0]);
        stringifiedData['release_to'] = String(ranges[1]);
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });
    setFormSubmitParams(stringifiedData);
  };

  const onGoToAddCart = () => {
    history.push(`/declare-cart-info`);
  };
  const onEditCart = (currentData: any) => {
    history.push(`/declare-cart-info`, currentData);
  };

  useEffect(() => {
    setTitle('Phát hành giỏ hàng');
    setBreadcrumb([
      { title: <a href="">Giỏ hàng</a> },
      { title: <a href="/cart-list">Phát hành giỏ hàng</a> },
    ]);
    refetch();
  }, [page, page_size, formSubmitParams]);

  return (
    <MainLayout>
      {/* <ModalEditCartList
        data={currentCartList}
        open={openModalEditCartList}
        setOpen={setOpenModalEditCartList}
      /> */}
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
        <Col span={12} className="flex justify-end">
          <Space>
            <Button onClick={onGoToAddCart}>
              <AddIcon />
              Tạo mới
            </Button>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>

      <Form
        form={form}
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'} mt-4`}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={6}>
              <Form.Item name="cart_code" label="Mã giỏ hàng">
                <Input placeholder="Nhập mã giỏ hàng" />
              </Form.Item>
            </Col>

            <Col className="" span={6}>
              <Form.Item name="cart_name" label="Tên giỏ hàng">
                <Input placeholder="Nhập tên giỏ hàng" />
              </Form.Item>
            </Col>

            <Col className="" span={6}>
              <Form.Item name="cart_type" label="Loại giỏ hàng">
                <Select placeholder="Chọn loại giỏ hàng">
                  {lstPofType?.data?.map((item) => (
                    <Option value={item.pof_type_code} key={item.id}>
                      {item.pof_type_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col className="" span={6}>
              <Form.Item name="department" label="Phòng ban phát hành">
                <Select />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={6}>
              <Form.Item name="created_by" label="Người khai báo">
                <Input placeholder="Nhập email người khai báo" className="" />
              </Form.Item>
            </Col>
            <Col className="" span={6}>
              <Form.Item name="release_date" label="Ngày phát hành">
                <RangePicker
                  placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                  format={'DD/MM/YYYY'}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={handleReset}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          dataSource={lstCartData?.data}
          scroll={{ x: 958 }}
          loading={getCartsLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: lstCartData?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
}
